export enum EntityReducers {
  sites = 'sites',
  preferences = 'preferences',
}
